import React from 'react'

import { SectionWrapper } from './SectionWrapper'
import { SectionTitle } from './SectionTitle'

const Section = ({ title, children }) => (
  <SectionWrapper>
    <SectionTitle>{title}</SectionTitle>
    {children}
  </SectionWrapper>
)

export { Section }

export * from './SectionWrapper'
export * from './SectionTitle'
export * from './SectionLabel'
export * from './SectionRow'
